if (!window.__ordcapTapMenusReady) {
  window.__ordcapTapMenusReady = true;

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const menuLink = target?.closest('.header-menu .menu-list__link[aria-haspopup="true"]');
      const openLinks = document.querySelectorAll(
        '.header-menu .menu-list__link[aria-expanded="true"]'
      );

      if (!menuLink) {
        openLinks.forEach((link) => link.setAttribute('aria-expanded', 'false'));
        return;
      }

      if (menuLink.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        event.stopPropagation();
        openLinks.forEach((link) => link.setAttribute('aria-expanded', 'false'));
        menuLink.setAttribute('aria-expanded', 'true');
      }
    },
    true
  );
}
